import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Card from '../common/Card';
import Button from '../common/Button';
import Modal from '../common/Modal';
import FormInput from '../forms/FormInput';
import { useToast } from '../common/Toast';
import { userService } from '../../services/user.service';
import { logout } from '../../store/slices/authSlice';
import { theme } from '../../config/theme';

const DeleteAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();

  const handleDelete = async () => {
    if (confirmText !== 'DELETE') return;
    
    setLoading(true);
    try {
      await userService.deleteAccount();
      toast.success('Your account has been permanently deleted.');
      dispatch(logout());
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to delete account.');
      setLoading(false);
    }
  };

  return (
    <>
      <Card padding="xl" style={{ border: `1px solid ${theme.colors.error}40` }}>
        <h2 style={{ 
          fontSize: theme.typography.fontSize.xl, 
          fontWeight: theme.typography.fontWeight.semibold,
          color: theme.colors.error,
          marginBottom: theme.spacing.md 
        }}>
          Danger Zone
        </h2>
        <p style={{ color: theme.colors.text.secondary, marginBottom: theme.spacing.lg }}>
          Permanently delete your account and all associated data. This action cannot be undone.
        </p>
        <Button 
          variant="outline" 
          onClick={() => setIsModalOpen(true)}
          style={{ borderColor: theme.colors.error, color: theme.colors.error }}
        >
          Delete Account
        </Button>
      </Card>

      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setConfirmText('');
        }}
        title="Delete Account"
      >
        <div style={{ marginBottom: theme.spacing.lg }}>
          <p style={{ color: theme.colors.text.secondary, marginBottom: theme.spacing.md }}>
            Are you absolutely sure you want to delete your account? This will permanently erase your profile, settings, and all associated data. This action <strong>cannot be undone</strong>.
          </p>
          <FormInput
            label="Please type DELETE to confirm"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="DELETE"
          />
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: theme.spacing.md }}>
          <Button 
            variant="ghost" 
            onClick={() => {
              setIsModalOpen(false);
              setConfirmText('');
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleDelete}
            disabled={confirmText !== 'DELETE' || loading}
            loading={loading}
            style={{ backgroundColor: theme.colors.error }}
          >
            Permanently Delete
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteAccount;
